import { RouteObject } from "react-router";
import PublicAccessibilityView from "views/public/accessibility/view";
import PublicPrivacyPolicyView from "views/public/privacy-policy/view";

export const publicRoutes: RouteObject[] = [
  {
    // start with nested routing
    path: "privacy-policy",
    element: <PublicPrivacyPolicyView />,
  },
  {
    path: "accessibility",
    element: <PublicAccessibilityView />,
  },
];
